export enum JobTaskStatus {
  STATUS_COMPLETED = 'COMPLETED',
  STATUS_FAILED = 'FAILED',
  STATUS_IN_PROGRESS = 'IN_PROGRESS',
  STATUS_SCHEDULED = 'SCHEDULED',
  STATUS_CANCELLED = 'CANCELLED',
  STATUS_WARNING = 'WARNING',
}
